module.exports = __webpack_public_path__ + "static/media/RealTimeCommunication_Elec_001.2c211270.png";